<script setup lang="ts">
import { onMounted } from 'vue'
onMounted(() => { })
</script>

<template>
  <div class="content">
    <div class="textbox">
      <div class="title">{{ $t('About.hai') }}</div>
      <div class="text">{{ $t('About.introduce') }}</div>
    </div>
    <div class="Mission-Vision">
      <div class="card">
        <svg class="iconpark-icon">
          <use href="#mission"></use>
        </svg>
        <div class="title">{{ $t('About.mission') }}</div>
        <div class="text">{{ $t('About.missiondesp') }}</div>
      </div>
      <div class="line"></div>
      <div class="card">
        <svg class="iconpark-icon">
          <use href="#vison"></use>
        </svg>
        <div class="title">{{ $t('About.vision') }}</div>
        <div class="text">{{ $t('About.visiondesp') }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  padding: 0 3.2rem;
  width: 100%;
  max-width: 144rem;
  border-radius: 1.6rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url('https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/round-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;

  .textbox {
    width: 100%;
    max-width: 109.2rem;
    margin-top: 16rem;
    display: flex;
    flex-direction: column;

    .title {
      width: 100%;
      font-size: 4.8rem;
      font-style: normal;
      font-weight: 600;
      line-height: 6.4rem;
      color: #000;
    }

    .text {
      max-width: 60.2rem;
      margin-top: 16px;
      color: rgba($color: #000000, $alpha: 0.4);
      font-family: PingFang SC;
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 400;
      line-height: 2.8rem;
    }

  }

  .Mission-Vision {
    margin: 9.8rem 0 8rem 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    max-width: 109.2rem;
    height: 35rem;
    // aspect-ratio: 1/0.32;
    flex-shrink: 0;
    border-radius: 1.4rem;
    border: 1px solid #FFF;
    background: rgba(255, 255, 255, 0.42);

    .line {
      width: 1px;
      height: 24.5rem;
      background: #D0D0D0;
    }

    .card {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 0 6rem;
      width: 100%;
      max-width: 40rem;
      align-self: stretch;
      border-radius: 1.6rem;
      margin: 0 .8rem;

      svg {
        width: 8.5rem;
        height: 8.5rem;
      }

      .title {
        margin-top: 4rem;
        color: #000;
        font-size: 2.7rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .text {
        margin-top: 1rem;
        color: #BEBEBE;
        text-align: center;
        font-family: PingFang SC;
        font-size: 2rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
}
</style>
